import {useEffect, useState} from "react";
import {VacancyItem} from "../types/vacancies";
import {useForm} from "antd/es/form/Form";
import {openSuccessNotification, showErrorNotification} from "../helpers/mainHelpers";
import {vacanciesService} from "../services/vacanciesService";
import {Modal} from "antd";
import {DeleteOutlined} from "@ant-design/icons";

export const useVacanciesController = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [vacanciesList, setVacanciesList] = useState<VacancyItem[]>([])
  const [selectedVacancy, setSelectedVacancy] = useState<VacancyItem | undefined>(undefined)
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)
  const [lastUpdate, setLastUpdate] = useState(0)
  const [form] = useForm()

  useEffect(() => {
    if (selectedVacancy) {
      form.setFieldsValue(selectedVacancy)
    } else {
      form.resetFields()
    }
  }, [selectedVacancy])

  useEffect(() => {
    fetchVacanciesList([])
  }, [lastUpdate])

  const toggleLastUpdate = () => {
    setLastUpdate(Date.now())
  }
  const toggleCreateModalOpen = () => {
    const value = !isCreateModalOpen
    setIsCreateModalOpen(value)
    if (value === false) {
      form.resetFields()
      setSelectedVacancy(undefined)
    }
  }

  const createVacancy = async (data: VacancyItem) => {
    setIsLoading(true)
    try {
      const createdItem = await vacanciesService.create(data)
      openSuccessNotification("Вакансію успішно створена!")
      toggleCreateModalOpen()
      toggleLastUpdate()
    } catch (error) {
      showErrorNotification({message: "Помилка створення вакансії!", description: JSON.stringify(error)});
    } finally {
      setIsLoading(false)
    }
  }

  const updateVacancy = async (data: VacancyItem) => {
    setIsLoading(true)
    try {
      const updatedRecord = await vacanciesService.update(data)
      toggleCreateModalOpen()
      toggleLastUpdate()
      openSuccessNotification("Вакансію успішно оновлено!")
    } catch (error) {
      showErrorNotification({message: "Помилка оновлення вакансії!", description: JSON.stringify(error)});
    } finally {
      setIsLoading(false)
    }
  }


  const fetchVacanciesList = async (queries: string[]) => {
    setIsLoading(true)
    try {
      const list = await vacanciesService.list(queries)
      setVacanciesList(list)
    } catch (error) {
      console.error(error)
      showErrorNotification({message: "Помилка завантаження вакансій!"});
    } finally {
      setIsLoading(false)
    }
  }

  const deleteVacancy = async (id: string) => {
    setIsLoading(true)
    try {
      await vacanciesService.delete(id)
      openSuccessNotification("Вакансію успішно видалено!")
      toggleLastUpdate()
    } catch (error) {
      showErrorNotification({message: "Помилка видалення вакансії!", description: JSON.stringify(error)});
    } finally {
      setIsLoading(false)
    }
  }
  const confirmDeleteRecord = (id: string) => {
    const {confirm} = Modal;
    confirm(
      {
        width: 400,
        icon: <DeleteOutlined/>,
        title: `Видалити вакансію?`,
        okText: "Видалити",
        okButtonProps: {danger: true},
        cancelText: "Cкасувати",
        onOk: async () => {
          await deleteVacancy(id)
        },
      });
  }

  const submitFormHandler = (data: VacancyItem) => {
    if (selectedVacancy) {
      updateVacancy({...data, $id: selectedVacancy.$id})
    } else {
      createVacancy(data)
    }
  }

  const editButtonHandler = (record: VacancyItem) => {
    setSelectedVacancy(record)
    toggleCreateModalOpen()
  }


  return {
    isLoading,
    vacanciesList,
    selectedVacancy,
    isCreateModalOpen,
    toggleCreateModalOpen,
    form,
    submitFormHandler,
    confirmDeleteRecord,
    editButtonHandler
  }
}

export default useVacanciesController